<div class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="fw-bold">Tenants</h2>
    <button class="btn btn-primary" (click)="openCreateTenant()">Add Tenant</button>
  </div>

  <!-- TENANTS TABLE -->
  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Name</th>
          <th>Rental</th>
          <th>Rent</th>
          <th>User</th>
          <th>Status</th>
          <th class="text-end"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tenant of tenants">
          <td>{{ tenant.fullName }}</td>
          <td>{{ tenant.rentalAddress }}</td>
          <td>${{ tenant.monthlyRent | number }}</td>

          <!-- USER LINK -->
          <td>
            <ng-container *ngIf="tenant.userId; else linkUser">
              <span class="text-muted">{{ tenant.email || 'Linked' }}</span>
            </ng-container>

            <ng-template #linkUser>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="openLinkUser(tenant)">
                Link User
              </button>
            </ng-template>
          </td>

          <td>
            <span
              class="badge"
              [class.bg-success]="tenant.status === 'active'"
              [class.bg-secondary]="tenant.status === 'archived'">
              {{ tenant.status }}
            </span>
          </td>

          <td class="text-end">
            <button
              class="btn btn-sm btn-outline-primary me-2"
              (click)="openEditTenant(tenant)">
              Edit
            </button>
            <button
              class="btn btn-sm btn-outline-danger"
              (click)="archiveTenant(tenant.id)">
              Archive
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<!-- =====================
     TENANT MODAL
     ===================== -->
<div *ngIf="isTenantModalOpen" class="app-modal-overlay" (click)="closeTenantModal()">
  <div class="app-modal" (click)="$event.stopPropagation()">

    <div class="app-modal-header">
      <h5>{{ editingTenantId ? 'Edit Tenant' : 'Create Tenant' }}</h5>
      <button class="btn-close" (click)="closeTenantModal()"></button>
    </div>

    <form [formGroup]="form" (ngSubmit)="saveTenant()" class="app-modal-body">
      <div class="row g-3">

        <div class="col-md-6">
          <label class="form-label">Full Name</label>
          <input class="form-control" formControlName="fullName">
        </div>

        <div class="col-md-6">
          <label class="form-label">Email</label>
          <input class="form-control" formControlName="email">
        </div>

        <div class="col-md-6">
          <label class="form-label">Phone</label>
          <input class="form-control" formControlName="phone">
        </div>

        <div class="col-md-6">
          <label class="form-label">Rental</label>
          <select
            class="form-select"
            formControlName="rentalId"
            (change)="onRentalChange(form.value.rentalId)">
            <option value="">Select rental</option>
            <option *ngFor="let r of rentals" [value]="r.id">
              {{ r.address }}
            </option>
          </select>
        </div>

        <div class="col-md-8">
          <label class="form-label">Rental Address</label>
          <input class="form-control" formControlName="rentalAddress" disabled>
        </div>

        <div class="col-md-4">
          <label class="form-label">Monthly Rent</label>
          <input type="number" class="form-control" formControlName="monthlyRent">
        </div>

        <div class="col-md-6">
          <label class="form-label">Start Date</label>
          <input type="date" class="form-control" formControlName="startDate">
        </div>

        <div class="col-12">
          <label class="form-label">Notes</label>
          <textarea class="form-control" rows="3" formControlName="notes"></textarea>
        </div>

      </div>

      <div class="app-modal-footer mt-4">
        <button type="button" class="btn btn-outline-secondary" (click)="closeTenantModal()">Cancel</button>
        <button type="submit" class="btn btn-success" [disabled]="form.invalid">
          Save Tenant
        </button>
      </div>
    </form>

  </div>
</div>

<!-- =====================
     LINK USER MODAL
     ===================== -->
<div *ngIf="isLinkUserModalOpen" class="app-modal-overlay" (click)="closeLinkUser()">
  <div class="app-modal" (click)="$event.stopPropagation()">

    <div class="app-modal-header">
      <h5>Link User to {{ linkingTenant?.fullName }}</h5>
      <button class="btn-close" (click)="closeLinkUser()"></button>
    </div>

    <form [formGroup]="linkUserForm" class="app-modal-body">

      <label class="form-label">Select User</label>
      <select class="form-select" formControlName="userId">
        <option value="">Select user</option>
        <option *ngFor="let u of users" [value]="u.uid">
          {{ u.email }}
        </option>
      </select>

    </form>

    <div class="app-modal-footer">
      <button class="btn btn-outline-secondary" (click)="closeLinkUser()">Cancel</button>
      <button
        class="btn btn-primary"
        (click)="confirmLinkUser()"
        [disabled]="linkUserForm.invalid">
        Link User
      </button>
    </div>

  </div>
</div>
